module.exports = __webpack_public_path__ + "static/img/banner-m-s.417ed73.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/banner-m-s.png
// module id = LUEB
// module chunks = 1